import React, {Component} from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import $ from 'jquery'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import TemplateSectionEditForm from "./form/edit.component.jsx";
const uuidv4 = require('uuid/v4')

class EditSectionModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.isCancelled = false
        const uniqueId = uuidv4()
        this.state = {
            modalId: this.props.modalId || 'template-sections-modal-' + uniqueId,
            currentRank: this.props.currentRank === undefined ? '' : this.props.currentRank,
            sectionId: this.props.sectionId || '',
            documentId: this.props.documentId || '',
            contentType: this.props.contentType || 'text',
            variables: this.props.variables || null,
            form: '',
        }
        this.closeModal = this.closeModal.bind(this)
        this.open = this.open.bind(this)
    }

    componentWillUnmount() {
        this.isCancelled = true
    }

    componentDidMount() {
        if (this.isCancelled) {
            return
        }
        this.open()
    }

    open() {
        if (this.isCancelled) {
            return
        }
        $('#' + this.state.modalId).modal('show')
        if (this.state.sectionId) {
            AppContext.getApiClient().get('/documents/' + this.state.documentId + '/sections/' + this.state.sectionId).then(res => {
                if (this.isCancelled) {
                    return
                }
                this.setState({
                    form: <TemplateSectionEditForm
                        value={res}
                        documentId={this.state.documentId}
                        onChange={this.closeModal}
                        onClose={this.closeModal}
                        className={" "}
                        contentTypeClassName={"modal-body pb-0 px-4"}
                        formClassName={"container-fluid"}
                        containerFormClassName={"modal-body pt-0"}
                        buttonClassName={"modal-footer"}
                        variables={this.state.variables}
                    />
                })
            })
        } else {
            this.setState({
                form: <TemplateSectionEditForm
                    documentId={this.state.documentId}
                    contentType={this.state.contentType}
                    currentRank={this.state.currentRank}
                    onChange={this.closeModal}
                    onClose={this.closeModal}
                    className={" "}
                    contentTypeClassName={"modal-body pb-0 px-4"}
                    formClassName={"container-fluid"}
                    containerFormClassName={"modal-body pt-0"}
                    buttonClassName={"modal-footer"}
                    variables={this.state.variables}
                />
            })
        }
    }

    closeModal(s) {
        if (this.isCancelled) {
            return
        }
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(s)
        }
    }

    render() {
        return (
            <div className="modal"
                 id={this.state.modalId}
                 role="dialog"
                 aria-labelledby={this.state.modalId+"Label"}
                 aria-hidden="true"
                 data-backdrop="static"
                 data-keyboard="false"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title h5" id={this.modalId+"Label"}>
                                <FormattedMessage
                                    id="template.sections.edit.modal.title"
                                    defaultMessage="Edit section"
                                />
                            </div>
                        </div>
                        {this.state.form}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(EditSectionModal)





// WEBPACK FOOTER //
// ./src/template/sections/editmodal.component.jsx